import createPlugin from "./createPlugin";
import SupportPanelsRenderer from "./Renderer";

const SupportPanelsPlugin = (settings) =>
    createPlugin({
        Renderer: SupportPanelsRenderer,
        Controls: () => null,
        ...settings,
    });

const SupportPanels = SupportPanelsPlugin();
export default SupportPanels;

export { SupportPanelsPlugin, SupportPanelsRenderer };
